import React, { Component } from 'react';
import ResetPasswordForm from './reset-password/ResetPasswordForm';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import fetchDux from '../../state/fetch-dux';
import Layout from '../ui/Layout';
import MetaTags from 'react-meta-tags';
import queryString from 'query-string';
import { Link } from 'react-router-dom';
import MetaLoader from '../ui/MetaLoader';

class ResetPasswordRoute extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);

    this.props.clearPostResetPassword();
    this.props.clearPostVerifyForgotPasswordToken();

    const {
      history,
      postVerifyForgotPasswordToken,
      location: { search }
    } = this.props;

    const { r } = queryString.parse(search || '');
    if (!r) return history.push('/');
    postVerifyForgotPasswordToken({ token: r });
    document.body.classList.add(
      'page-template',
      'page-template-page-templates',
      'page-template-shop-login',
      'page-template-page-templatesshop-login-php',
      'page',
      'page-id-240',
      'page-child',
      'parent-pageid-212',
      'no-sidebar'
    );
  }
  componentWillUnmount() {
    this.props.clearPostResetPassword();
    this.props.clearPostVerifyForgotPasswordToken();
    document.body.classList.remove(
      'page-template',
      'page-template-page-templates',
      'page-template-shop-login',
      'page-template-page-templatesshop-login-php',
      'page',
      'page-id-240',
      'page-child',
      'parent-pageid-212',
      'no-sidebar'
    );
  }
  render() {
    const {
      postResetPassword,
      verifyError,
      verifyInProgress,
      verifyResult,
      postResetPasswordResult,
      postResetPasswordError,
      location: { search }
    } = this.props;

    const { valid } = verifyResult || {};
    const { success } = postResetPasswordResult || {};

    const { r: token } = queryString.parse(search || '');

    const scrollToTop = () => window.scrollTo(0, 0);
    const handlePostResetPassword = ({ email, password }) =>
      postResetPassword(
        { email, password, token },
        'reset-password-form',
        null,
        scrollToTop
      );

    return (
      <Layout>
        <MetaLoader title="Reset Password | Twomey" />
        <MetaTags>
          <title>Reset Password | Twomey</title>
          <meta property="og:site_name" content="Twomey.com" />
          <meta property="og:title" content="Reset Password | Twomey" />
          <meta property="og:type" content="article" />
          <meta
            property="og:url"
            content="https://twomey.com/account/forgot-password"
          />
        </MetaTags>
        <div id="content" className="site-content">
          <div id="primary" className="content-area">
            <main
              id="main"
              className="site-main shop-page nohero extra cart-page"
            >
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-md-10">
                    <div className="row">
                      <div className="col-md-12">
                        <h1 className="smaller">Reset Password</h1>
                        <br />
                      </div>
                      <div className="col-md-6">
                        <div className="login-box-left">
                          {!success &&
                            !verifyInProgress &&
                            verifyError &&
                            <div>
                              <h3>Error</h3>
                              <p>
                                This link is no longer valid. If you need to reset your password, please submit a new request.
                              </p>
                            </div>}
                          {!success &&
                            !verifyInProgress &&
                            valid &&
                            <ResetPasswordForm
                              onSubmit={handlePostResetPassword}
                              postResetPasswordError={postResetPasswordError}
                            />}
                          {success &&
                            <div>
                              <h3>Password changed!</h3>
                              <p>
                                Your password was successfully changed. Please log in with your new password.
                              </p>
                              <Link
                                className="btn btn-primary"
                                to="/account/login"
                              >
                                Login
                              </Link>
                            </div>}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </main>
          </div>
          <div className="container text-right">
            <a href="#top" className="back-to-top" onClick={scrollToTop}>
              Back to top
            </a>
          </div>
        </div>
      </Layout>
    );
  }
}

const mapState = state => {
  const {
    error: verifyError,
    inProgress: verifyInProgress,
    result: verifyResult
  } = state.postVerifyForgotPasswordToken.toJS();

  const {
    error: postResetPasswordError,
    result: postResetPasswordResult
  } = state.postResetPassword.toJS();

  return {
    verifyError,
    verifyInProgress,
    verifyResult,
    postResetPasswordResult,
    postResetPasswordError
  };
};

const mapDispatch = dispatch =>
  bindActionCreators(
    {
      postResetPassword: fetchDux.postResetPassword.createAction,
      postVerifyForgotPasswordToken: fetchDux.postVerifyForgotPasswordToken.createAction,
      clearPostResetPassword: fetchDux.postResetPassword.clearAction,
      clearPostVerifyForgotPasswordToken: fetchDux.postVerifyForgotPasswordToken.clearAction
    },
    dispatch
  );

export default connect(mapState, mapDispatch)(ResetPasswordRoute);
